<script setup>
import { Container, PrimaryButton } from '@codinglabsau/ui'
import Table from '@/Components/Tables/Ships.vue'
import PageHeader from '@/Components/PageHeader.vue'
import HeadMetaTags from '@/Components/HeadMetaTags.vue'
import ReputationModal from '@/Components/Reputation/ReputationModal.vue'

defineProps({
  ships: Object,
  can: Object,
})
</script>

<template>
  <HeadMetaTags
    title="Ships"
    description="A Index of all of our recorded ships that transported Convicts to Australia."
    :canonical="route('ships.index')"
    :url="route('ships.index')"
  />

  <Container>
    <PageHeader title="Ships">
      <template #actions>
        <PrimaryButton v-if="can.create" rel="nofollow" :href="route('ships.create')">
          Add a Ship
        </PrimaryButton>
        <div v-else>
          <ReputationModal>
            <template #trigger>
              <PrimaryButton> Add a Ship</PrimaryButton>
            </template>
          </ReputationModal>
        </div>
      </template>
    </PageHeader>
    <div class="rounded-b-lg bg-white px-3 pt-4">
      <Table
        :search-url="route('ships.index')"
        :ships="ships"
      />
    </div>
  </Container>
</template>
